export default __webpack_public_path__ + "static/media/www.marilizcastillo.com_.bf43e21c.png";